import { Box, Typography, styled, Card } from '@mui/material';
import noFoundImage from '../../assets/cannotFind.gif';

const DuckImage = styled('img')(({ theme }) => ({
    'width': '200px',
}));

export const NoBookingFound = () => {
    return (
        <Card>
            <Box className="padding" align="center" justify="center">
                <Typography variant="h2" sx={{ textAlign: 'center', m: 1 }}>
                    Sorry, We cannot find this booking
                </Typography>
                <Typography variant="h5" sx={{ textAlign: 'center', m: 1 }}>
                    Navigate back to the history page to find the booking
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', m: 1 }}>
                    <DuckImage src={noFoundImage} />
                </Box>
            </Box>
        </Card>
    );
};

export default NoBookingFound;
